import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { baseTheme } from '../../../../theme';
import { setLibraryListConfig, getLibraryPostsAction } from '../../../../store/library/actions';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
    },
    formControlContainers: {
      marginRight: theme.spacing(2),
    },
    formControls: {
      width: '100%',
    },
  }),
);

export default function LibrarySearchControls(props: any) {
  const classes = useStyles(baseTheme);
  const sizeAdjust = 12;
  const dispatch = useDispatch();
  const currUser = useSelector((state: any) => state.auth.currUser);
  const searchConfig = useSelector((state: any) => state.library.listConfig);

  const submitSearch = () => {
    getLibraryPostsAction(currUser.uid, searchConfig, dispatch);
  };

  const handleFormChange = (prop: any) => (event: any) => {
    console.log('searchConfigs', searchConfig);
    const updatedValues = {
      ...searchConfig,
      [prop]: event.target.value,
      pagination: {
        ...searchConfig.pagination,
        lastItem: null,
      },
    };

    dispatch(setLibraryListConfig(updatedValues));
  };

  const handleDropDownChange = (prop: any) => (event: any) => {
    const handleChange = handleFormChange(prop);
    handleChange(event);
  };

  return (
    <Grid item container xs={12} md={sizeAdjust} className={classes.root}>
      <Grid item xs={4} className={classes.formControlContainers}>
        <FormControl className={classes.formControls}>
          <TextField
            size="small"
            label="Search"
            value={searchConfig.search}
            variant="outlined"
            onChange={handleFormChange('search')}
            InputProps={{
              endAdornment:
                (<InputAdornment position="end">
                  <IconButton
                    aria-label="search posts"
                    edge="end"
                    onClick={submitSearch}>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>),
            }} />
        </FormControl>
      </Grid>

      <Grid item xs={3} className={classes.formControlContainers}>
        <FormControl variant="outlined" className={classes.formControls} size="small">
          <InputLabel id="sort-posts">Sort</InputLabel>
          <Select
            labelId="sort-posts"
            id="sort-posts"
            value={searchConfig.sort}
            label="Sort"
            onChange={handleDropDownChange('sort')}
          >
            <MenuItem value="title-ascend">Title Ascending</MenuItem>
            <MenuItem value="title-descend">Title Descending</MenuItem>
            <MenuItem value="date-ascend">Posted Ascending</MenuItem>
            <MenuItem value="date-descend">Posted Descending</MenuItem>
            <MenuItem value="addedOn-ascend">Added Ascending</MenuItem>
            <MenuItem value="addedOn-descend">Added Descending</MenuItem>
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
}
